import { defineAction } from '~/prix'
import propertyImprovementsCreateAction from './propertyImprovementsCreate.action.json' with { type: 'json' }

import { z } from 'zod'
import { propertyImprovementsObject } from '../propertyImprovementsObject'

const propertyImprovementsCreateDefinition = defineAction({
  ...propertyImprovementsCreateAction,

  input: propertyImprovementsObject.pick({
    id: true,
    residenceId: true,
    improvementType: true,
    quantity: true,
    description: true,
    createdAt: true,
    updatedAt: true,
  }),
  output: z.object({}),
})

export default propertyImprovementsCreateDefinition
